import Vue from 'src/views/base'
import { Component, Watch } from 'vue-property-decorator'
import template from './un-active.vue'
import PageTips from '../mixins'
import { Store as UserStore } from 'store/modules/user'

@Component({
    name: 'unActive',
    mixins: [ template ],
    components: {
        PageTips
    }
})
export default class UnActive extends Vue {
    @UserStore.getter('userInfo') userInfo 

    title = null
    smallTips = null
    buttonText = null
    redirectUrl = null

    created() {
    }

    // get title() {
    //     return this.userInfo.userStatus === 0 ? '您的账号处于【未激活】状态，请先激活' : '该账号处于 【未激活】 状态，无法为您找回密码。'
    // }

    // get smallTips() {
    //     return this.userInfo.userStatus === 0 ? '' : '您可以选择重新注册一个新账号。'
    // }
    
    // get buttonText() {
    //     return this.userInfo.userStatus === 0 ? '立即激活' : '快速注册'
    // }

    // get redirectUrl() {
    //     return this.userInfo.userStatus === 0 ? '/activation' : '/registry'
    // }

    @Watch('userInfo', {
        immediate: true,
        deep: true
    })
    handleWatchUserInfo(info) {
        if (info.userStatus === 0) {
            this.title = '您的账号处于【未激活】状态，请先激活'
            this.smallTips = ''
            this.buttonText = '立即激活'
            this.redirectUrl = '/activation'
        } else {
            this.title = '该账号处于【未激活】状态，无法为您找回密码。'
            this.smallTips = '您可以选择重新注册一个新账号。'
            this.buttonText = '快速注册'
            this.redirectUrl = '/registry'
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/page/main/un-active/index.js